import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import { ANALYTICS_PROVIDERS, SNOWPLOW_EVENTS } from '../../analytics.const';
import type { GAEventPayload } from '../../analytics.types';

import {
	VEHICLE_DETAILS_IMAGE_EVENTS,
	VEHICLE_DETAILS_IMAGE_SECTIONS,
	VEHICLE_DETAILS_IMAGE_ZOOM_LEVELS,
} from './galleryEvents.consts';
import type { ZoomEventsParams } from './galleryEvents.types';

const { GOOGLE_ANALYTICS } = ANALYTICS_PROVIDERS;

export const triggerZoomInImageEvent = ({ maxZoom = 3, section, zoomLevel }: ZoomEventsParams): void => {
	const zoomLevelLabel =
		zoomLevel > maxZoom
			? VEHICLE_DETAILS_IMAGE_ZOOM_LEVELS.ANOTHER_LEVEL
			: VEHICLE_DETAILS_IMAGE_ZOOM_LEVELS[`LEVEL_${zoomLevel}`];

	const snowplowEventPayload = getSnowplowEventPayload({
		category: VEHICLE_DETAILS_IMAGE_SECTIONS[section],
		customData: { label: zoomLevelLabel },
		name: VEHICLE_DETAILS_IMAGE_EVENTS.ZOOM_IN.snowplow,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	const googleAnalyticsEventPayload: GAEventPayload = {
		action: VEHICLE_DETAILS_IMAGE_EVENTS.ZOOM_IN.ga,
		category: VEHICLE_DETAILS_IMAGE_SECTIONS[section],
		isLegacyEvent: false,
		label: zoomLevelLabel,
	};

	logAnalyticsEvent({ eventPayload: snowplowEventPayload });
	logAnalyticsEvent({ eventPayload: googleAnalyticsEventPayload, provider: GOOGLE_ANALYTICS });
};
